import { Grid, TextField, Box, Button } from '@material-ui/core';
import { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import ListClusterlets from './ListClusterlets'
import CreateCancel from '../../atoms/buttons/CreateCancel';
import { useForm } from "react-hook-form";
import { basic, validationMessages } from '../../../config/validations';
import { createTemplate } from '../../../store/blueprint/actions'
import { handleSnackBar, handleTopRightInfo } from '../../../store/global/actions';
import { getBlueprintDetails } from '../../../store/global/selectors';




const CreateTemplate = (props) => {
    const { onCompletion, onClose, textCapitalise } = props;
    const { register, handleSubmit, formState: { errors } } = useForm();

    const dispatch = useDispatch();
    const [nodes, setNodes] = useState([]);
    const [alert, setAlert] = useState([]);
    const [loading, setLoading] = useState(false);
    const [file, setFile] = useState("");
    const [error, setError] = useState("");
    const [filePath, setFilePath] = useState('');
    const blueprintDetails = useSelector(getBlueprintDetails);

    // const [invalidFile, setInvalidFile] = useState(false)



    const messages = { ...validationMessages };

    const onNodeSelect = async (node, checked) => {
        checked ? setNodes([...nodes, node]) : setNodes(nodes.filter(n => n.id !== node.id));
    }


    const isValidFile = (file) => file.type === "image/png";

    const handleFileSelection = (e) => {
        setFile(e.target.files[0].name);
        let isValid = isValidFile(e.target.files[0]);

        if (!isValid) {
            setError("Please upload a image file (.png)");
            // setInvalidFile(true);
        } else {
            setError("");
            setFilePath(e.target.files[0]);
        }
    };



    const onCreate = async ({ name }) => {

        const payload = {
            name,
            nodes,
            blueprintId: blueprintDetails.id,
            docid: blueprintDetails.docid,
        }

        if (nodes.length == 0) {
            dispatch(handleSnackBar({ open: true, message: 'Template needs atleast one clusterlet', severity: "error" }));
            return false;
        }

        if (name == '') {
            dispatch(handleSnackBar({ open: true, message: 'Template must have a name', severity: "error" }));
            return false;
        }

        // dispatch(handleSnackBar({ open: true, message: 'Creating template...', severity: "info" }));
        dispatch(handleTopRightInfo({ message: 'Creating template...', open: true, }))

        setLoading(true);
        let formData = new FormData()
        formData.append('templateData', JSON.stringify(payload))
        formData.append('image', filePath)


        dispatch(createTemplate(formData)).then((res) => {
            setLoading(false);
            console.log('res----->', res)
            if (res.status) {
                console.log('res----->', res)
                dispatch(handleTopRightInfo({ open: false }));
                dispatch(handleSnackBar({ open: true, message: res.message, severity: "success" }));


            }
            else {
                dispatch(handleTopRightInfo({ open: false }));
                dispatch(handleSnackBar({ open: true, message: res.message, severity: "error" }));

            }
            onClose();

        })


    }

    return (
        <Grid container direction={"row"} spacing={3}>
            <Grid item xs={12}>
                <TextField
                    name="name"
                    autoFocus
                    fullWidth
                    type={"text"}
                    required={true}
                    label={"Name"}
                    placeholder={""}
                    variant="outlined"
                    inputRef={register({ ...basic, })}
                    error={errors?.name ? true : false}
                    helperText={errors?.name ? messages[errors?.name?.type] : ''}
                />
            </Grid>
            <Grid item xs={4}>
                <Button variant="contained" component="label" color="primary" className={textCapitalise}>
                    Upload PNG Icon
                    <input type="file" hidden onChange={(e) => handleFileSelection(e)} accept="image/png" />
                </Button>
            </Grid>
            <Grid item xs={3}  >
                {file != "" && <Box color="text.primary" style={{ marginLeft: -20, marginTop: 10 }}> {file}</Box>}
            </Grid>
            <Grid item xs={12}>
                <ListClusterlets onSelect={onNodeSelect} nodes={nodes} />

            </Grid>
            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }} >
                <CreateCancel onCreate={handleSubmit(onCreate)} onCancel={onClose} createDisable={loading} />
            </Grid>

        </Grid>


    )
}

export default CreateTemplate;